import {PageBase} from "@/app2/shared/layouts/PageBase";
import {makeStyles} from "tss-react/mui";
import {AdminSideMenuContent} from "@/app2/pages/ManagerView/AdminSideMenuContent";
import {Route, Routes} from "react-router-dom";
import {Box, ThemeProvider} from "@mui/material";
import {AdminCoursesPage} from "@/app2/pages/ManagerView/Pages/Courses/AdminCoursesPage";
import {AdminSettingsPage} from "@/app2/pages/ManagerView/Pages/AdminSettings";
import {AdminLessonsPage} from "@/app2/pages/ManagerView/Pages/Lessons/AdminLessonsPage";
import {AdminQuizzesPage} from "@/app2/pages/ManagerView/Pages/Quizzes/AdminQuizzesPage";
import {AdminLeaderboardPage} from "@/app2/pages/ManagerView/Pages/Leaderboard";
import {AdminAnnouncementsPage as AdminAnnouncementsPageV2} from "@/app2/pages/ManagerView/Pages/Announcements";
import {AdminContainer} from "@/pages/ManagerView/AdminContainer";
import {AdminPlaylistsPage} from "@/app2/pages/ManagerView/Pages/Playlists";
import {adminTheme as createAdminTheme} from "@/templates/adminTheme";
import useDevCycleSdk from "@/hooks/useDevCycleSdk";
import {useMemo} from "react";
import {TeamProgressPage} from "@/app2/pages/TeamProgressPage";
import {ScheduledReportsRouter} from "@/app2/pages/ManagerView/Pages/ScheduledReports/ScheduledReportsRouter";
import {AdminUsersPage as AdminUsersPageV2} from "@/app2/pages/ManagerView/Pages/Users";

const useStyles = makeStyles()((theme) => ({
	pageBase: {
		height: "calc(100% + 24px)",
		backgroundColor: theme.palette.grey[900],
		backgroundPosition: "-1px -1px",
		backgroundSize: "74px 74px",
		backgroundImage: "linear-gradient(to right, rgba(255, 255, 255, 0.03) 1px, transparent 1px), linear-gradient(to bottom, rgba(255, 255, 255, 0.03) 1px, transparent 1px)"
	},
	tableContainer: {
		boxSizing: "border-box",
		padding: "40px 28px 32px",
		marginBottom: "52px",
		position: "relative",
		zIndex: "1"
	}
}));

export const ContentManager: React.FC = () => {
	const {classes} = useStyles();
	const {playlists, announcements, teamProgress, monthEndReport, leaderboards} = useDevCycleSdk();

	const adminTheme = useMemo(() => createAdminTheme(), []);

	return (
		<PageBase
			className={classes.pageBase}
			sideMenuWidthOverride={"283px"}
			contentWidth={"100%"}
			sideBarContent={<AdminSideMenuContent />}
		>
			<ThemeProvider theme={adminTheme}>
				<AdminContainer size="wide">
					<Box className={classes.tableContainer}>
						<Routes>
							<Route index element={<AdminUsersPageV2 />}/>
							{playlists && <Route path="playlists/*" element={<AdminPlaylistsPage />} />}
							<Route path="users/*" element={<AdminUsersPageV2 />} />
							<Route path="courses/*" element={<AdminCoursesPage />} />
							<Route path="lessons/*" element={<AdminLessonsPage />} />
							{announcements && <Route path="announcements/*" element={<AdminAnnouncementsPageV2 />} />}
							<Route path="quizzes/*" element={<AdminQuizzesPage />} />
							{leaderboards && <Route path="leaderboard/*" element={<AdminLeaderboardPage />} />}
							<Route path="settings" element={<AdminSettingsPage />} />
							{teamProgress && <Route path="team-progress" element={<TeamProgressPage />} />}
							{monthEndReport && <Route path="scheduled-reports/*" element={<ScheduledReportsRouter />} />}
						</Routes>
					</Box>
				</AdminContainer>
			</ThemeProvider>
		</PageBase>
	);
}